import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { HEADER, SUMMARY_TLDR } from './lib/data';
import { ReactComponent as Logo } from './img/tbt-logo.svg';
import { ReactComponent as NavIcon } from './img/icon-menu.svg';
import { MobileOnlyView, BrowserView, TabletView, isBrowser, isTablet } from 'react-device-detect';
import './Header.css';

export default class Header extends Component {
  static propTypes = {
    section: PropTypes.string,
    sectionSlug: PropTypes.string,
    template: PropTypes.string,
    onToggleNavigation: PropTypes.func,
  }

  handleNavIconClick = () => {
    this.props.onToggleNavigation();
  }

  handleLogoClick = () => {
    window.location.href = `#/?p=1`;
  }

  render() {
    let title = this.props.template !== HEADER
      ? this.props.section
      : null;

    if (title === SUMMARY_TLDR) {
      title = "Summary";
    }

    if (isBrowser || isTablet) {
      title = "The Culture Book";
    }

    return (
      <header className={this.props.sectionSlug}>
        <Row>
          <Col span={24}>
            <a onClick={this.handleLogoClick} className="logo-link">
              <Logo className="logo" />
            </a>
            <div className="title">
              {title}
            </div>
              <a onClick={this.handleNavIconClick} className="nav-icon">
                <MobileOnlyView>
                  <NavIcon />
                </MobileOnlyView>
                <BrowserView>
                  Menu
                </BrowserView>
                <TabletView>
                  Menu
                </TabletView>
              </a>
          </Col>
        </Row>
      </header>
    );
  }
}
